import React from 'react';
import { SnippetVariable, generateHtmlFormCode } from '../../../utils/schemaSnippets';
import { SyntaxHighlighter } from './SyntaxHighlighter';

export interface HtmlFormSnippetProps {
  variables: SnippetVariable[];
  formUrl: string;
  redirectUrl: string;
  honeypot: string;
  isDefaultSample?: boolean;
  className?: string;
}

export const HtmlFormSnippet: React.FC<HtmlFormSnippetProps> = ({
  variables,
  formUrl,
  redirectUrl,
  honeypot,
  isDefaultSample = false,
  className = '',
}) => {
  const code = generateHtmlFormCode(formUrl, redirectUrl, honeypot, variables, isDefaultSample);
  return <SyntaxHighlighter code={code} language="html" className={className} />;
};
